<template>
  <div class="page-visibility"></div>
</template>

<script>
  export default {
      name: 'PageVisibility',

      mounted() {
        if (typeof document.hidden === 'undefined') return 
        document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
      },

      methods:{
        handleVisibilityChange () {
          this.$emit((document.hidden ? 'documentInactive' : 'documentActive'))
        }
      },

      destroyed(){
        if (typeof document.hidden === 'undefined') return 
        document.removeEventListener('visibilitychange', this.handleVisibilityChange, false)
      }
  }
</script>